import classicImg from '@/assets/classic-package.jpg';
import majesticImg from '@/assets/majestic-package.jpg';
import royalImg from '@/assets/royal-package.jpg';
import twilightImg from '@/assets/twilight-package.jpg';

export interface BookingPackageCN {
  id: string;
  name: string;
  price: number;
  image: string;
  features: string[];
}

export const PACKAGES_CN: BookingPackageCN[] = [
  {
    id: 'classic',
    name: '标准套餐',
    price: 599,
    image: classicImg,
    features: [
      '🚐 迪拜市区接送',
      '☕ 起飞点无限量茶/咖啡和水',
      '🎈 热气球体验（45-60分钟）',
      '📜 飞行员签名飞行证书'
    ]
  },
  {
    id: 'majestic',
    name: '豪华套餐',
    price: 699,
    image: majesticImg,
    features: [
      '🚐 迪拜市区接送',
      '☕ 起飞前茶/咖啡和水',
      '🍽 营地美食早餐',
      '🐪 骑骆驼体验（5-10分钟）',
      '🦅 猎鹰合影',
      '🎈 热气球体验（45-60分钟）',
      '📜 飞行员签名飞行证书'
    ]
  },
  {
    id: 'royal',
    name: '尊贵套餐',
    price: 1550,
    image: royalImg,
    features: [
      '🚐 迪拜市区接送',
      '☕ 起飞点茶/咖啡和水',
      '🍽 营地美食自助早餐',
      '🐪 骑骆驼体验（5-10分钟）',
      '🏍 四轮摩托车（10-15分钟）',
      '🏜 沙丘冲浪（15-20分钟）',
      '🦅 猎鹰合影',
      '🎈 热气球体验（45-60分钟）',
      '📜 飞行员签名飞行证书'
    ]
  },
  {
    id: 'twilight',
    name: '过夜套餐',
    price: 1950,
    image: twilightImg,
    features: [
      '🚗 迪拜市区私人接送',
      '🕒 第一天接送时间：下午3:00-3:30',
      '🏜 沙丘冲浪（20分钟）',
      '☕ 欢迎饮料 + 椰枣和阿拉伯甜点',
      '🐪 骑骆驼 + 🦅 猎鹰合影 + 🎨 指甲花彩绘',
      '💃 现场表演（肚皮舞、旋转舞、火舞）',
      '🍖 烧烤晚餐 + 无限量软饮',
      '🏕 营地过夜住宿',
      '🕓 第二天凌晨4:00前往热气球地点',
      '☕ 起飞点茶/咖啡和水',
      '🍽 美食早餐',
      '🎈 热气球体验（45-60分钟）',
      '📜 飞行员签名飞行证书'
    ]
  }
];
